import * as types from "../actions/actionTypes";
import initialState from "./initialState";

/*
 * ALL EVENTS ARE CATALOGED BY GROUP ID
 *  state = [{name: "Curry Run" ... },]
 */

function insertEventByDate(event, eventArray) {
    var insertionPoint = 0;
    var eventStart = new Date(event.startDate); 
    eventArray.map((e, idx) => {
        var checkDate = new Date(e.startDate)
        if (checkDate < eventStart) {
            insertionPoint = idx + 1;
        }
    })
    eventArray.splice(insertionPoint, 0, event);
    return eventArray; 
}

export default function eventsReducer(state = initialState.events, action) {
    switch (action.type) {
        case types.LOAD_USER_EVENTS:
            if (state.length == 0) {
                return action.events;
            }
            let loadEventState = [];
            action.events.map(e => {
                loadEventState.push(e);
            })
            state.map((e) => {
                action.events.map((newE, idx) => {
                    if (e.id == newE.id && e.fullyLoaded) {
                        loadEventState.splice(idx, 1, e);
                    }
                })
            })
            return loadEventState;    
        case types.LOAD_EVENT:
            let loadSingleEventState = [];
            var eventLoaded = false; 
            if (state.length > 0) {
                state.map(e => {
                    if (e.id == action.event.id) {
                        loadSingleEventState.push(action.event)
                        eventLoaded = true;
                    }
                    else {
                        loadSingleEventState.push(e)
                    }
                })
            } else {
                loadSingleEventState.push(action.event)
                eventLoaded = true;
            }
            if (!eventLoaded) {
                loadSingleEventState = insertEventByDate(action.event, loadSingleEventState); 
            }
            return loadSingleEventState
        case types.CREATE_EVENT:
            let newEventState = [];
            state.map(e => {
                newEventState.push(e);
            })
            if (newEventState.length > 0) {
                newEventState = insertEventByDate(action.event, newEventState); 
            } else {
                newEventState.push(action.event)
            }
            return newEventState
        case types.EDIT_EVENT:
            let eventEditArray = [];
            state.map(e => {
                if (e.id == action.event.id) {
                    eventEditArray.push(action.event)
                }
                else {
                    eventEditArray.push(e)
                }
            })
            return eventEditArray;
        case types.CANCEL_EVENT:
            let eventCancelledArray = [];
            state.map(e => {
                if (e.id == action.eventId) {
                    e.cancelled = true;
                    e.cancellationReason = action.cancellationReason;
                    e.cancelledOn = new Date(); 
                }
                eventCancelledArray.push(e);
            })
            return eventCancelledArray;
        case types.DELETE_EVENT:
            let eventDeletedArray = [];
            state.map(e => {
                if (e.id != action.eventId) {
                    eventDeletedArray.push(e);
                }
            })
            return eventDeletedArray;
        case types.EVENT_USER_PARTICIPATION_UPDATE:
            let eventStatusArray = [];
            state.map(e => {
                if (e.id == action.eventId) {
                    var userFound = false;
                    e.participants.map(p => {
                        if (p.userId.toUpperCase() == action.user.userId.toUpperCase()) {
                            p.status = action.status;
                            userFound = true; 
                        }
                    })
                    if (!userFound) {
                        e.participants.push({ firstName: action.user.firstName, surname: action.user.surname, userId: action.user.userId, hasAvatar: action.user.hasAvatar, status: action.status })
                    }

                }
                eventStatusArray.push(e);
            })
            return eventStatusArray;
        case types.LOGOUT_SUCCESS:
            return initialState.events;
        default:
            return state;
    }
}

/*EVENTS

    export const LOAD_GROUP_EVENTS = "LOAD_GROUP_EVENTS";
    export const LOAD_USER_EVENTS = "LOAD_USER_EVENTS";
    export const LOAD_EVENT = "LOAD_EVENT";
    export const CREATE_EVENT = "CREATE_EVENT";
    export const EDIT_EVENT = "EDIT_EVENT";
    export const EDIT_EVENT = "EVENT_USER_PARTICIPATION_UPDATE";
    export const CANCEL_EVENT = "CANCEL_EVENT";
    export const DELETE_EVENT = "DELETE_EVENT";

*/



// WEBPACK FOOTER //
// ./src/redux/reducers/eventsReducer.js